import { v4 as uuidv4 } from "uuid";
import { CONFIG } from "~/config";
import { IDescriptionResponse, IError, ILoginSessionId, IPOIDescription, ISubscription, ISubscriptionAttributes, ISubscriptionUpdate, ISubscriptionWithDescription, ISubscriptionsMeCurrentResponse, ISubscriptionsMeResponse } from "./interfaces";
import { description } from "~/util/providers/poiagg";

const BASE_URL = "/share-position";
const ENDPOINT_URL = `${BASE_URL}/subscriptions`;

export async function subscriptionsMe(): Promise<{
	subscriptions: Array<ISubscriptionWithDescription>;
	timestamp: string;
}> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/me`, {
		method: "GET",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: ISubscriptionsMeResponse = await response.json();

		// posbirame info o POIich ze subscriptions a obohatime si data o description tech POIu
		const pois = [];

		json.items.forEach(subscription => {
			subscription.routeParts?.forEach(routePart => {
				const { source } = routePart.poi;

				// vygenerujeme id POIum, co maji source coor
				if (source === "coor") {
					routePart.poi.id = `${routePart.poi.lon},${routePart.poi.lat}`;
				}

				pois.push({ source, id: routePart.poi.id });
			});
		});

		// nacteme si ty description
		const result = await description(pois, {
			fetchPhoto: false,
			lang: CONFIG.langPriority,
			reviews: true,
			wikimedia: true,
		});
		// @ts-ignore
		const descriptions: { [ key: string ] : IPOIDescription } = result.result;

		// zamichame description do dat a ta vratime
		return {
			subscriptions: json.items.map(function addDescriptions(subscription: ISubscription): ISubscriptionWithDescription {
				return {
					...subscription,
					...subscription.routeParts?.length
						? {
							routeParts: subscription.routeParts?.length
								? subscription.routeParts.map(routePart => ({
									...routePart,
									poi: {
										...routePart.poi,
										description: descriptions[`${routePart.poi.source}${routePart.poi.id}`],
									},
								}))
								: [],
						}
						: {
							routeInfo: null,
							routeParts: [],
						},
					whereami: null,
				};
			}),
			timestamp: json.timestamp,
		};
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function subscriptionsMeCurrent(timestamp = ""): Promise<{
	subscriptions: Array<ISubscriptionUpdate>;
	timestamp: string;
}> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/me/current${timestamp ? `?since=${encodeURIComponent(timestamp)}` : ""}`, {
		method: "GET",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: ISubscriptionsMeCurrentResponse = await response.json();

		return {
			subscriptions: json.items,
			timestamp: json.timestamp,
		};
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function getSubscription(id: string): Promise<ISubscription> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/${encodeURIComponent(id)}`, {
		method: "GET",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: ISubscription = await response.json();

		return json;
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function setSubscriptionAttributes(id: string, attributes: ISubscriptionAttributes): Promise<void> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/${encodeURIComponent(id)}`, {
		method: "POST",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
		body: JSON.stringify(attributes),
	});

	if (response?.status === 200) {
		return Promise.resolve();
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function deleteSubscription(id: string): Promise<IDescriptionResponse> {
	const response = await fetch(`${CONFIG.requestUrl}${ENDPOINT_URL}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
	});

	if (response?.status === 200) {
		const json: IDescriptionResponse = await response.json();

		return json;
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}

export async function login(): Promise<ILoginSessionId> {
	const response = await fetch(`${CONFIG.requestUrl}${BASE_URL}/login`, {
		method: "POST",
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"X-Correlation-Id": uuidv4(),
		},
		credentials: "include",
		body: JSON.stringify({
			deviceId: uuidv4(),
			userName: "Anonym",
		}),
	});

	if (response?.status === 200) {
		const json: ILoginSessionId = await response.json();

		return json;
	} else if (response?.status === 422) {
		const json: IError = await response.json();

		throw new Error(JSON.stringify(json));
	}

	throw new Error(response?.status.toString());
}
